import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ROUTES } from "@/app/routes";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useNavigate } from "react-router";
import { IPetinfoProps } from "../../customer_profile_interface";
import PetInformationDefaultView from "./PetInformationDefaultView";



const PetInformation: React.FC<IPetinfoProps> = () => {
  const { getRouteKey } = useRouter();

  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { petDetails, customerId, petId } = routeState.state as ICustomerProfileState;

  const navigate = useNavigate();

  const handleAddPet = () => {
    let url = "";
    if (customerId && petId) {
      url = `${getRouteKey("ADD_PET", "url")}/${customerId}/${petId}`;
    } else {
      url = `${getRouteKey("ADD_PET", "url")}/${customerId}${location.search}`;
    }
    navigate(url);
  };
  const handleEditPet = () => {
    let url = "";
    if (customerId && petId) {
      url = `${getRouteKey("EDIT_PET", "url")}/${customerId}/${petId}`;
    } else {
      url = `${getRouteKey("EDIT_PET", "url")}/${customerId}${location.search}`;
    }
    navigate(url);
  };



  return (
    <>
      <PetInformationDefaultView handleAddPet={handleAddPet} petDetails={petDetails} handleEditPet={handleEditPet} />
    </>
  );
};

export default PetInformation;
